import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            {/* 404 Icon */}
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
              <span className="text-2xl font-bold text-red-600">404</span>
            </div>
            
            {/* Title */}
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Strona nie została znaleziona
            </h1>
            
            {/* Description */}
            <p className="text-gray-600 mb-8">
              Przepraszamy, ale strona której szukasz nie istnieje lub została przeniesiona.
            </p>
            
            {/* Action Buttons */}
            <div className="space-y-3">
              <Link
                to="/"
                className="w-full flex justify-center items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-primary hover:bg-blue-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-primary transition-colors duration-200"
              >
                <Home className="w-4 h-4 mr-2" />
                Wróć do strony głównej
              </Link>
              
              <button
                onClick={() => window.history.back()}
                className="w-full flex justify-center items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-primary transition-colors duration-200"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Wróć do poprzedniej strony
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
